export const useSingleCarTranslations = createGlobalState(() => {
	const { $i18n } = useNuxtApp()
	const t = (key: string) => $i18n.t(key).toString()

	const tr = computed(() => ({
		orSimilar: t('modules.cars_module.single_car.or_similar'),
		onTrainStation: t('modules.cars_module.single_car.on_train_station'),
		onAirport: t('modules.cars_module.single_car.on_airport'),
		deposit: t('modules.cars_module.cars.single_car.deposit'),
		noDeposit: t('modules.cars_module.cars.single_car.no_deposit'),
		freeCancellation: t('modules.cars_module.cars.single_car.free_cancellation'),
		collectionPointAt: t('modules.cars_module.cars.single_car.collection_point_at'),
		noMileageLimit: t('modules.cars_module.cars.single_car.no_mileage_limit'),
		mileageLimitPerDay: t('modules.cars_module.cars.single_car.mileage_limit_per_day'),
		settledInPricelistCurrency: t('modules.cars_module.cars.single_car.settled_in_pln'),
		year: t('modules.cars_module.cars.single_car.year'),
		for: t('common.for'),
		day: t('common.day'),
		days: t('common.days'),
		select: t('common.select'),
	}))

	return { tr, locale: $i18n.locale }
})
